
import { useEffect, useRef, useState } from "react";
import { DataBean } from "./DataBean";
import { Singleton } from '../Singleton';
import { _single } from "./EntityCatalog";
import { spinnerStore } from "../../Stores/SpinnerStore/SpinnerStore";

// type FieldConfig = {
//     name: string;
//     allowZero?: boolean;
// };

// function useDataBean(Entity:any) {
function useDataBean<T extends DataBean>(Entity: T) {

    const [instance] = useState(Entity);
    const [lista, setLista] = useState<any>([]);
    const [customObj, setCustomObj] = useState<any>([]);
    const [bean, setBean] = useState<any>({});
    const [errors, setErros] = useState<any>('');
    const [spin, setSpin] = useState(spinnerStore.getState());
    const [requiredConfig, setRequiredConfig] = useState<string[]>([]);
    const [missingFields, setMissingFields] = useState<string[]>([]);


    useEffect(() => {
        const unsubscribe = spinnerStore.subscribe((isActive, activeCount) => {
            setSpin(isActive);
        });
        return () => unsubscribe();
    }, []);


    useEffect(() => {
        if (errors !== '')
            setTimeout(() => {
                setErros('');
            }, 4000);
    }, [errors])



    const newBean = () => {
        instance.bean = {};
        setBean(instance.bean);
    }

    const update = async () => {


        try {
            instance.bean = bean;
            await instance.update().then((resp: any) => { setBean(resp) });
        } catch (error) {
            console.error(error);
            setErros(error);
        }

    };
    const updateCustonBean = async (miBean: any) => {


        try {
            instance.bean = miBean;
            await instance.updateCustonBean(miBean).then((resp: any) => { setBean(resp) });
        } catch (error) {
            console.error(error);
            setErros(error);
        }

    };
    const deleteItem = async (idItem: number) => {

        let isDelete = false;
        try {
            await instance.delete(idItem).then((resp: any) => { });
            isDelete = true;
        } catch (error) {
            console.error(error);
            setErros(error);
        }

        return isDelete;
    };
    const deleteItemVoid = async (idItem: number) => {

        let isDelete = false;
        try {
            await instance.deleteVoid(idItem).then((resp: any) => { });
            isDelete = true;
        } catch (error) {
            console.error(error);
            setErros(error);
        }

        return isDelete;
    };
    const getLista = async (params: any, rows: number | null) => {

        try {

            const temp: any = await instance.getList(params, rows);
            setLista(temp);
        } catch (error) {
            console.error(error);
            setErros(error);
        }


    };
    const getListaLike = async (params: any, rows: number | null) => {

        try {
            const temp: any = await instance.getList(params, rows);
            setLista(temp);
        } catch (error) {
            console.error(error);
            setErros(error);
        }

    };
    const getCustomFunction = async (service: string, hash: string, propsArray: any, setMiObject?: (state: any) => void, doAfter?: () => void) => {


        try {
            const retorno: any = await instance.getCustomService(service, hash, propsArray);
            ////console.log('Rrn', retorno);
            if (setMiObject) {
                setMiObject(retorno);
                //console.log(retorno)
            }
            else {
                if (retorno.DataBeanProperties) {
                    if (retorno.DataBeanProperties.ErrorMessage) {
                        setErros(retorno.DataBeanProperties.ErrorMessage);
                    }
                    else if (retorno.DataBeanProperties.ObjectValue) {
                        setCustomObj(retorno.DataBeanProperties.ObjectValue);
                    }
                    else {
                        Entity.dataBeanList = retorno.DataBeanProperties;
                        setCustomObj(retorno.DataBeanProperties);
                    }
                }
                else
                    setCustomObj(retorno);
            }

            if (doAfter) {
                doAfter()
            }

        } catch (error) {
            console.error(error);
            setCustomObj(undefined);
            setErros(error);
        }


    };

    const handleChange = (e: any) => {
      
        const newBean = { ...bean }; // Crear una copia nueva del objeto        
        newBean[e.target.name] = _single.getValueInput(e);
        setBean(newBean); // Actualizar el estado con la nueva copia

    }
    function processValue(value: any): number | string | boolean {
        if (typeof value === 'number') {
            return value; // Si es un número, lo retorna como número
        } else if (typeof value === 'boolean') {
            return value; // Si es boolean, lo retorna como boolean
        } else if (typeof value === 'string') {
            const parsedNumber = parseFloat(value); // Intenta convertir el string a número
            if (!isNaN(parsedNumber) && isFinite(parsedNumber)) {
                return parsedNumber; // Si la conversión es exitosa, retorna el número
            } else if (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') {
                return value.toLowerCase() === 'true'; // Convierte "true"/"false" a boolean
            } else {
                return value; // Si no es un número ni boolean, retorna el string original
            }
        } else {
            return value.toString(); // Para otros tipos de datos, los convierte a string
        }
    }

    /**
     * Registra campos requeridos
     */
    const addRequiredFields = (fields: string[]) => {
        setRequiredConfig(fields);
    }

    /**
     * Verifica si un campo es requerido
     */
    const isRequired = (field: string): boolean => {
        return requiredConfig.includes(field);
    }

    /**
     * Verifica si un campo está inválido
     */
    const isMissing = (field: string): boolean => {
        return missingFields.includes(field);
    }

    /**
     * Valida el formulario y devuelve los campos faltantes
     */
    const validate = (): string[] => {
        const missing = requiredConfig.filter((field) => {
            const value = bean[field];

            if (value === undefined || value === null) return true;

            if (typeof value === "string") {
                return value.trim() === "";
            }

            if (typeof value === "number") {
                return Number.isNaN(value);
            }

            return false;
        });

        setMissingFields(missing);
        return missing;
    }

    /**
     * Valida todo el formulario
     */
    const validateForm = (): boolean => {
        const missing = validate();
        console.log('campor faltantes', missing)
        return missing.length === 0;
    }


    return {
        instance,
        lista,
        customObj,
        bean,
        errors,
        spin,
        missingFields,
        update,
        validate,
        updateCustonBean,
        newBean,
        setBean,
        setLista,
        deleteItem,
        deleteItemVoid,
        getLista,
        getCustomFunction,
        getListaLike,
        handleChange,
        addRequiredFields,
        isRequired,
        isMissing,
        validateForm
    };
}


export default useDataBean;